// src/utils/dateUtils.js

/**
 * Sunucudan gelen ve zaten T�rkiye saati olan bir tarih metnini
 * kullan�c�ya g�stermek i�in formatlar (�rn: "13.07.2025, 16:19:00").
 * @param {string | null | undefined} dateString - Tarih metni.
 * @returns {string} Formatlanm�� yerel tarih veya "-".
 */
export const formatDateToLocal = (dateString) => {
    if (!dateString) return '-';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';

    // Tarihi T�rkiye format�na uygun olarak formatla.
    return date.toLocaleString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};


// <<< YEN� EKLENEN FONKS�YON >>>
/**
 * JavaScript Date nesnesini, .NET API'sinin DateTime olarak anlayaca��
 * lokal (yerel) bir string format�na �evirir (YYYY-MM-DDTHH:mm:ss).
 * .toISOString() G�B� UTC'YE �EV�RMEZ!
 * @param {Date | string} dateInput - JavaScript Date nesnesi veya tarih metni.
 * @returns {string | null} Formatlanm�� tarih metni veya null.
 */
export const formatDateForApi = (dateInput) => {
    if (!dateInput) return null;

    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return null;

    const pad = (num) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Aylar 0'dan ba�lar
    const day = pad(date.getDate());
    const hour = pad(date.getHours());
    const minute = pad(date.getMinutes());
    const second = pad(date.getSeconds());

    // API'nin en rahat anlayaca�� format: "2025-07-15T14:30:00"
    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
};